import { useState, useEffect, useMemo } from 'react';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { useEvent } from 'services/gecko-events';

export function useBots() {
  const [isLoading, setIsLoading] = useState(true);
  const [bots, setBots] = useState([]);
  const fetchBots = useMemo(() => {
    return () => {
      GeckoRequest.get('/bots', { page: 1 })
        .then((payload) => {
          const { data } = payload;
          setBots(data);
          setIsLoading(false);
        })
        .catch(renderError)
        .finally(() => setIsLoading(false));
    };
  }, []);
  const markImportAsComplete = useMemo(() => {
    return ({ bot_id }) => {
      const newBots = bots.map((bot) => {
        if (bot.id !== bot_id) {
          return bot;
        }
        return Object.assign({}, bot, { bot_import_id: null });
      });
      setBots(newBots);
    };
  }, [bots]);

  useEffect(() => {
    fetchBots();
  }, []);

  useEvent('bot:created', fetchBots);
  useEvent('bot:updated', fetchBots);
  useEvent('bot:deleted', fetchBots);
  useEvent('botimport:completed', markImportAsComplete);

  return [bots, isLoading];
}

export function useBot(botId) {
  const [bot, setBot] = useState(null);
  const [bots, isLoading] = useBots();
  useEffect(() => {
    const bot = bots.find((bot) => bot.id === botId);
    setBot(bot || null);
  }, [botId, bots]);
  return [bot, isLoading];
}
